import { esAnalista, useAuth } from "./auth";
export const STAGES = [
  { id: "prospecto", l: "Prospecto", c: "#A39E93" },
  { id: "integracion", l: "Integración de expediente", c: "#6B8CAE" },
  { id: "analisis", l: "Análisis", c: "#E8A23C" },
  { id: "en_revision", l: "En revisión", c: "#E8643C" },
  { id: "comite", l: "Comité", c: "#8B5CF6" },
  { id: "aprobado", l: "Aprobado", c: "#2F9E6E" },
  { id: "dispuesto", l: "Dispuesto", c: "#111111" },
  { id: "rechazado", l: "Rechazado", c: "#D9534F" },
];
export const SL = Object.fromEntries(STAGES.map((s) => [s.id, s]));
export const BORR = ["prospecto", "integracion", "analisis"];
export const DIRECTOR_ONLY = ["comite", "aprobado", "rechazado"];
export const BAND_CLS = { A: "bg-emerald-100 text-emerald-800", B: "bg-lime-100 text-lime-800", C: "bg-amber-100 text-amber-800", D: "bg-orange-100 text-orange-800", E: "bg-rose-100 text-rose-800" };
export const wizardStepFor = (stage) => ({ prospecto: 1, integracion: 2, analisis: 6 }[stage] || 1);

// Mismas reglas que el backend (POST /expedientes/{id}/stage).
export const canMove = (user, deal, to) => {
  if (deal.bloqueado) return [false, "Crédito de cartera importada: Dispuesto es la etapa final"];
  if (user.role === "comercial") return ["prospecto", "integracion"].includes(deal.stage) && ["prospecto", "integracion"].includes(to) ? [true] : [false, "El rol Comercial solo mueve entre Prospecto e Integración"];
  const dir = user.role === "director";
  const cur = deal.stage;
  if (to === cur) return [false, ""];
  if (BORR.includes(to)) {
    if (BORR.includes(cur)) return [true];
    if (["en_revision", "comite"].includes(cur)) return dir ? [true] : [false, "Solo el Director puede devolver para corrección"];
    return [false, "Deal bloqueado: crea una nueva versión para editarlo"];
  }
  if (to === "en_revision") return BORR.includes(cur) ? [true] : [false, "Solo se envía a revisión desde Prospecto, Integración o Análisis"];
  if (to === "comite") return !dir ? [false, "Solo el Director puede pasar a Comité"] : cur === "en_revision" ? [true] : [false, "A Comité solo desde En revisión"];
  if (to === "rechazado") return !dir ? [false, "Solo el Director puede aprobar o rechazar"] : [...BORR, "en_revision", "comite"].includes(cur) ? [true] : [false, "El deal ya está cerrado"];
  if (to === "aprobado") return !dir ? [false, "Solo el Director puede aprobar o rechazar"] : ["en_revision", "comite"].includes(cur) ? [true] : [false, "Solo se aprueba un deal En revisión o en Comité"];
  if (to === "dispuesto") return cur !== "aprobado" ? [false, "Solo se dispone un deal Aprobado"] : dir || deal.owner_id === user.id ? [true] : [false, "Solo el Director o el analista dueño"];
  return [false, ""];
};

export const StageChip = ({ stage, testid }) => (
  <span className="inline-flex items-center gap-1.5 rounded-full border border-[#E2DDD5] bg-white px-2.5 py-0.5 text-xs font-semibold" data-testid={testid}>
    <span className="h-2 w-2 rounded-full" style={{ background: SL[stage]?.c }} />{SL[stage]?.l}
  </span>
);
export const ScoreChip = (p) => (esAnalista(useAuth().user) ? <ScoreChipIn {...p} /> : null);

const ScoreChipIn = ({ score, band }) => (score == null ? <span className="text-xs text-[#8C867A]">sin score</span>
  : <span className={`rounded-full px-2 py-0.5 text-xs font-bold ${BAND_CLS[band] || ""}`} data-testid="score-chip">{score} · {band}</span>);
export const initials = (n = "") => n.split(" ").filter(Boolean).slice(0, 2).map((x) => x[0]).join("").toUpperCase();
